import { useMemo, useState } from 'react'
import useGetter from 'useGetter'
import * as api from './api'

const useCareCounter = ({ english }) => {
    const [cared, setCared] = useState(false)
    const [careError, setCareError] = useState(null)
    const localStorageCare = useMemo(() => localStorage.getItem('cared'), [])

    const [gettingCareCounter, careCounter, careCounterError] = useGetter(() =>
        api.getCareCounter()
    )

    const CARE_COUNTER_ADJUSTMENT = 18000

    const careCounterValue = (careCounter ? careCounter + CARE_COUNTER_ADJUSTMENT : 0);
    const caredValue = cared && !localStorageCare ? 1 : 0
    const calculatedCareCounter = careCounterValue + caredValue

    let beginning = english ? 'No one ' : 'Ingen '
    const end = english ? 'care, do you?' : 'bryr seg, gjør du?'

    if (calculatedCareCounter) {
        beginning = `${calculatedCareCounter} ${
            english ? 'people' : 'personer'
        } `
    }

    const careText =
        gettingCareCounter && !careCounterError ? 'Loading...' : beginning + end

    const doCare = async () => {
        try {
            if (careError) {
                setCareError(null)
            }

            !cared && setCared(true)
            await api.incrementCareCounter()
            localStorage.setItem('cared', 'true')
        } catch (e) {
            setCared(false)
            setCareError('Det skjedde en feil, vennligst prøv igjen')
            throw e
        }
    }

    return {
        careText,
        cared: cared || !!localStorageCare,
        careError,
        doCare,
    }
}

export default useCareCounter
